import React from 'react';
import './about.css';
import CV from '../../assets/Abdulhamid_CV.pdf'
import Info from './Info'
import Lottie from 'lottie-react';

import Contact from '../../../src/animation/about1.json'

const About = () => {
    return(
        <section className="about section" id="about">
            <h2 className="section__title">About Me</h2>
            <span className="section__subtitle">My introduction</span>

            <div className="about__container container grid">
            <Lottie className="Lottie__contact"
                  animationData={Contact} // JSON data of your animation
                  loop={true}
                  autoplay={true}
                />
                <div className="about__data">
                    <Info />

                    <p className="about__description">
                        I'm a full-stack developer with 3 years of experience, skilled in building web applications, workflow automations, and practical AI-assisted systems. I'm a collaborative team player with strong communication skills, committed to continuous learning and delivering robust solutions in dynamic environments.
                    </p>

                    <a download="" href={CV} className="about__button">Download CV
                    <i className="bx bx-file about__button-icon"></i>
                    </a>
                </div>
            </div>
        </section>
    )
}

export default About;
